import { browserHistory } from 'react-router';
import * as api from '../api';
import {
  getLang,
  getIsHappeningsFetching,
  getIsEditionsFetching,
  getIsRelatedFetching,
  getIsPageFetching,
  getIsThemeFetching,
  getIsLocationFetching,
  getIsPeopleFetching,
} from '../reducers';

// happenings
const recieveHappenings = (edition, response) => ({
  type: 'RECIEVE_HAPPENINGS',
  edition,
  response,
});

const requestHappenings = () => ({
  type: 'REQUEST_HAPPENINGS',
});

export const fetchHappenings = edition => (dispatch, getState) => {
  const state = getState();
  const lang = getLang(state);
  const isFetching = getIsHappeningsFetching(state);
  if (isFetching) {
    return Promise.resolve();
  }
  dispatch(requestHappenings());

  return api.fetchContent({ url: 'happenings', edition: edition.id, lang }).then((response) => {
    dispatch(recieveHappenings(edition, response));
  });
};

// People
const recievePeople = (edition, response) => ({
  type: 'RECIEVE_PEOPLE',
  edition,
  response,
});

const requestPEOPLE = () => ({
  type: 'REQUEST_PEOPLE',
});

export const fetchPeople = edition => (dispatch, getState) => {
  const state = getState();
  const lang = getLang(state);
  const isFetching = getIsPeopleFetching(state);
  if (isFetching) {
    return Promise.resolve();
  }
  dispatch(requestPEOPLE());

  return api.fetchContent({ url: 'people', edition: edition.id, lang }).then((response) => {
    dispatch(recievePeople(edition, response));
  });
};

// THEME
const recieveTheme = (edition, response) => ({
  type: 'RECIEVE_THEME',
  edition,
  response,
});

const requestTheme = () => ({
  type: 'REQUEST_THEME',
});

export const fetchTheme = edition => (dispatch, getState) => {
  const state = getState();
  const lang = getLang(state);
  const isFetching = getIsThemeFetching(state);
  if (isFetching) {
    return Promise.resolve();
  }
  dispatch(requestTheme());

  return api.fetchContent({ url: 'theme', edition: edition.id, lang }).then((response) => {
    dispatch(recieveTheme(edition, response));
  });
};

// Location
const recieveLocation = (edition, response) => ({
  type: 'RECIEVE_LOCATION',
  edition,
  response,
});

const requestLocation = () => ({
  type: 'REQUEST_LOCATION',
});

export const fetchLocation = edition => (dispatch, getState) => {
  const state = getState();
  const lang = getLang(state);
  const isFetching = getIsLocationFetching(state);
  if (isFetching) {
    return Promise.resolve();
  }
  dispatch(requestLocation());

  return api.fetchContent({ url: 'location', edition: edition.id, lang }).then((response) => {
    dispatch(recieveLocation(edition, response));
  });
};

// Workshops
const requestWorkshops = () => ({
  type: 'REQUEST_WORKSHOPS',
});

const recieveWorkshops = (edition, response) => ({
  type: 'RECIEVE_WORKSHOPS',
  edition,
  response,
});

export const fetchWorkshops = edition => (dispatch, getState) => {
  const state = getState();
  const lang = getLang(state);
  dispatch(requestWorkshops());
  return api.fetchContent({ url: 'workshops', edition: edition.id, lang }).then((response) => {
    const sorted = response.sort((a, b) => a.date < b.date);
    dispatch(recieveWorkshops(edition, sorted));
  });
};

// Projects
const requestProjects = () => ({
  type: 'REQUEST_PROJECTS',
});

const recieveProjects = (edition, response) => ({
  type: 'RECIEVE_PROJECTS',
  edition,
  response,
});

export const fetchProjects = edition => (dispatch, getState) => {
  const state = getState();
  const lang = getLang(state);
  dispatch(requestProjects());
  return api.fetchContent({ url: 'projects', edition: edition.id, lang }).then((response) => {
    dispatch(recieveProjects(edition, response));
  });
};

// Editions
const requestEditions = () => ({
  type: 'REQUEST_EDITIONS',
});

const recieveEditions = (response, edition) => ({
  type: 'RECIEVE_EDITIONS',
  response,
  edition,
});

export const changeEdition = (direction) => {
  browserHistory.push('/');
  return {
    type: 'CHANGE_EDITION',
    direction,
  };
};

export const fetchEditions = edition => (dispatch, getState) => {
  const state = getState();
  const lang = getLang(state);
  if (getIsEditionsFetching(state)) {
    return Promise.resolve();
  }
  dispatch(requestEditions());
  return api.fetchContent({ url: 'editions', lang }).then((response) => {
    const sorted = response.sort((a, b) => parseInt(b.year, 10) - parseInt(a.year, 10));
    dispatch(recieveEditions(sorted, edition));
  });
};

// Related
const recieveRelated = (contentId, response) => ({
  type: 'RECIEVE_RELATED',
  contentId,
  response,
});

const requestRelated = () => ({
  type: 'REQUEST_RELATED',
});

export const fetchRelated = contentId => (dispatch, getState) => {
  const state = getState();
  if (getIsRelatedFetching(state)) {
    return Promise.resolve();
  }
  dispatch(requestRelated());
  return api.fetchRelatedContent({ url: 'related', contentId }).then((response) => {
    dispatch(recieveRelated(contentId, response));
  });
};

// Static
const recievePage = (pageId, response) => ({
  type: 'RECIEVE_PAGE',
  pageId,
  response,
});

const requestPage = () => ({
  type: 'REQUEST_PAGE',
});

export const fetchPage = pageId => (dispatch, getState) => {
  const state = getState();
  const lang = getLang(state);
  if (getIsPageFetching(state)) {
    return Promise.resolve();
  }
  dispatch(requestPage());
  return api.fetchPageContent({ pageId, lang })
    .then((json) => {
      dispatch(recievePage(pageId, json));
    });
};


// Modal
export const updateModalImage = payload => (dispatch) => {
  dispatch({
    type: 'UPDATE_MODAL_IMAGE',
    payload,
  });
};

export const updateModalImages = images => (dispatch) => {
  dispatch({
    type: 'UPDATE_MODAL_IMAGES',
    payload: {
      all: images,
    },
  });
};

export const changeModalImage = direction => (dispatch) => {
  dispatch({
    type: 'CHANGE_MODAL_IMAGE',
    direction,
  });
};

export const closeModal = () => (dispatch) => {
  dispatch({
    type: 'CLOSE_MODAL',
  });
};

export const setLang = lang => (dispatch) => {
  dispatch({
    type: 'SET_LANGUAGE',
    lang,
  });
};



// WEBPACK FOOTER //
// ./js/actions/index.js